import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './App.css'; // Import the CSS file for styling

const API_URL = 'https://backend-worker.ricardosampaiopt.workers.dev/'; // Update with your backend URL

function App() {
  const [races, setRaces] = useState([]);
  const [filteredAge, setFilteredAge] = useState(null); // State to manage the filter
  const [filteredCircuit, setFilteredCircuit] = useState(null); // State to manage the filter

  useEffect(() => {
    axios 
      .get(API_URL + 'upcoming')
      .then((response) => setRaces(response.data))
      .catch((error) => console.error('Error fetching race data:', error));
  }, []);

  const handleFilter = (ageCategory) => {
    filteredAge !== ageCategory ? setFilteredAge(ageCategory) : setFilteredAge();
  };


  const handleCircuitFilter = (category) => {
    filteredCircuit !== category ? setFilteredCircuit(category) : setFilteredCircuit();
  };

  return (
    <div className="app">
      <header className="header">
        <h1>Torneios Federados Padel</h1>
      </header>

      {/* Filter Buttons */}
      <div className="filter-buttons">
      <button
          className={filteredCircuit === 'FIP' ? 'active' : ''}
          onClick={() => handleCircuitFilter('FIP')}
        >
          FIP
        </button>
      <button
          className={filteredAge === 'Absolutos' ? 'active' : ''}
          onClick={() => handleFilter('Absolutos')}
        >
          Absolutos
        </button>
        <button
          className={filteredAge === 'Jovens' ? 'active' : ''}
          onClick={() => handleFilter('Jovens')}
        >
          Jovens
        </button>
        <button
          className={filteredAge === 'Veteranos' ? 'active' : ''}
          onClick={() => handleFilter('Veteranos')}
        >
          Veteranos
        </button>
        <button
          className={filteredAge === 'Adaptado' ? 'active' : ''}
          onClick={() => handleFilter('Adaptado')}
        >
          Adaptado
        </button>
      </div>

      {/* Race List */}
      <div className="race-list">
        {races
          .filter((race) => (!filteredAge || race.age === filteredAge) && (!filteredCircuit || race.circuit === filteredCircuit)) // Show all if no filter is selected
          .map((race, index) => (
            <div className="race-card" key={index} data-age={race.age} data-circuit={race.circuit}>
              <div className="race-image">
                <img
                  src={
                    race.photo ||
                    'https://i.imgur.com/STOK0rj.jpeg'
                  }
                  alt={race.name}
                />
              </div>
              <div className="race-details">
                <h2 className="race-name">{race.name}</h2>
                
                <p className="race-date">🏠 {race.club}</p>
                <p className="race-date">🏆 {race.age}{race.type ? " - "+ race.type : "" }</p>
                <p className="race-date">📅 {race.formattedStart} a {race.formattedEnd}</p>
                <p className="race-location">🗺️ {race.local ? race.local + ", " +race.county : "Por Definir"}</p>
                <p className="race-distance">🧑🏻 {race.categories}</p>
                {race.link ? (
                  <a
                    href={race.link}
                    className="race-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Link para as inscrições
                  </a>
                ) : (
                  <span className="race-link race-link-disabled">
                    Inscrições indisponíveis
                  </span>
                )}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

export default App;
